import { Api, createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAppConfigObject } from "../../appConfig.interfaces";

export const iataLookupApi: any = createApi({
  reducerPath: "iataLookupApi",
  baseQuery: fetchBaseQuery({
    method: "POST",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "POST, GET",
      "Access-Control-Allow-Origin": "*",
    },
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    iataLookup: builder.query({
      query: (arg: IIataLookup) => {
        return {
          url: `${arg.config.LEGACY_LOCATIONS_API_BASE_URL}/iata/code/${arg.iata}?topLevelDomain=${arg.config.TOP_LEVEL_DOMAIN}`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useIataLookupQuery, useLazyIataLookupQuery } = iataLookupApi;

interface IIataLookup {
  iata: string;
  config: IAppConfigObject;
}
